// Unified review-session sitting-size policy (srs-v2 spec §4.2, amended —
// see 2026-07-28-srs-v2-fsrs-design.md changelog: "unified with the
// restoration cap ... into one constant"). Two named states, one source of
// truth — replacing REVIEW_DAILY_CAP (review-queue.ts) and
// RESTORATION_CAP_DEFAULT (restoration.ts), which were previously defined
// independently, with comments claiming they answer "different questions"
// and "may diverge" — contradicting the spec's own instruction. Values are
// unchanged: 60 normally, 20 while the user is in the restoration register.
export const REVIEW_SITTING_SIZE_DEFAULT = 60
export const REVIEW_SITTING_SIZE_RESTORATION = 20
